import { observer } from 'mobx-react';
import * as React from 'react';
import Loader from '../../../../../../Loader';
import LearningCollectionEditStore from '../../../Store';
import { BrowseCatalog } from '../../../../Types';
import FiltersWithLearningCollectionsReady from './FiltersWithLearningCollectionsReady';

interface Props {
  store: LearningCollectionEditStore;
  browseCatalog: BrowseCatalog;
}

const FiltersWithLearningCollections: React.FC<Props> = ({ store, browseCatalog }) => {
  switch (store.learningDesignsStore.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'error':
      return <></>;
    case 'ready':
      return (
        <FiltersWithLearningCollectionsReady
          store={store}
          browseCatalog={browseCatalog}
          learningDesignsResource={store.learningDesignsStore.state.learningDesignsResource}
        />
      );
  }
};

export default observer(FiltersWithLearningCollections);
